import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { breadcrumbList } from "@/lib/schema";
import { InsightsIndex } from "@/components/insights/InsightsIndex";

const TITLE = "أدلة ومقالات شهادات الأيزو | عراق سيرت";
const DESC =
  "إجابات مباشرة حول تكلفة شهادة الأيزو وإجراءاتها والاعتماد ومعايير النفط والغاز في العراق والخليج. أدلة عملية من عراق سيرت.";

export const Route = createFileRoute("/ar/insights/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: absolute("/ar/insights") },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: "ar_IQ" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [
      { rel: "canonical", href: absolute("/ar/insights") },
      ...hreflangLinks("/insights"),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbList([
            { name: "الرئيسية", path: "/ar" },
            { name: "مقالات ودلائل", path: "/ar/insights" },
          ]),
        ),
      },
    ],
  }),
  component: InsightsIndex,
});
